// Third party library imports
import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router, UrlTree } from '@angular/router';
import { isObservable, map } from 'rxjs';

// Zopup library imports
import { StorageKey, StorageService } from '@zopup/zop-shared';
import { BranchDto } from '@zopup/zop-types';

// Internal project imports
import { TenantGuard } from './tenant.guard';

export const BranchGuard: CanActivateFn | CanActivateChildFn = (route, state) =>
{
    const router: Router = inject(Router);

    const baseResult = TenantGuard(route, state); // Call the base guard
    const selectedBranch = inject(StorageService).getItem<BranchDto>(StorageKey.branch);
    
    let isRouteAllowed = false;
    // Handle boolean directly
    if (typeof baseResult === 'boolean' && baseResult) {
        isRouteAllowed = baseResult && (selectedBranch !== undefined && selectedBranch !== null);
        
        if (!isRouteAllowed) {
            const urlTree = router.parseUrl('branch-selection');
            return urlTree;
        }
        return isRouteAllowed;
    }

    // Handle UrlTree directly
    if (baseResult instanceof UrlTree) {
        return baseResult;
    }

    // Handle Observable<boolean | UrlTree>
    if (isObservable(baseResult)) {
        return baseResult.pipe(
            map(result => {
                if (typeof result === 'boolean' && result) {
                    isRouteAllowed = result && (selectedBranch !== undefined && selectedBranch !== null);
                    if (!isRouteAllowed) {
                        const urlTree = router.parseUrl('branch-selection');
                        return urlTree;
                    }
                }
                return result; // If result is UrlTree, pass it directly
            })
        );
    }

    // Handle Promise<boolean | UrlTree>
    if (baseResult instanceof Promise) {
        return baseResult.then(result => {
            if (typeof result === 'boolean' && result) {
                isRouteAllowed = result && (selectedBranch !== undefined && selectedBranch !== null);
                if (!isRouteAllowed) {
                    const urlTree = router.parseUrl('branch-selection');
                    return urlTree;
                }
            }
            return result; // If result is UrlTree, pass it directly
        });
    }

    // Default to a safe fallback if no match
    return false;
};
